var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVoted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.001,
    height: 32,
    viewBox: "0 0 32.001 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(-6642 119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_115",
    "data-name": "Rectangle 115",
    d: "M14.5-.5h2A14.446,14.446,0,0,1,27.107,4.186,16.448,16.448,0,0,1,31.5,15.5a16.448,16.448,0,0,1-4.393,11.314A14.446,14.446,0,0,1,16.5,31.5h-2A14.446,14.446,0,0,1,3.893,26.814,16.448,16.448,0,0,1-.5,15.5,16.448,16.448,0,0,1,3.893,4.186,14.446,14.446,0,0,1,14.5-.5Zm2,30.933a13.483,13.483,0,0,0,9.9-4.374A15.352,15.352,0,0,0,30.5,15.5,15.352,15.352,0,0,0,26.4,4.941,13.483,13.483,0,0,0,16.5.567h-2A13.483,13.483,0,0,0,4.6,4.941,15.352,15.352,0,0,0,.5,15.5,15.352,15.352,0,0,0,4.6,26.059a13.483,13.483,0,0,0,9.9,4.374Z",
    transform: "translate(6642.5 -118.5)",
    fill: "#8e50a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211755_heart_icon",
    "data-name": "211755_heart_icon",
    d: "M76.347,83a4.763,4.763,0,0,0-3.783,1.865,4.791,4.791,0,1,0-7.231,6.267l6.745,6.812.486.491.486-.491,6.615-6.682A4.808,4.808,0,0,0,76.347,83Z",
    transform: "translate(6585.436 -192.728)",
    fill: "#8e50a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoted);
export default __webpack_public_path__ + "static/media/icon-voted.b16b0d1107ee18545464f6d8aef4e17d.svg";
export { ForwardRef as ReactComponent };